import { Dropdown } from '../../../Dropdown'
import { isEmpty } from 'lodash'
import React from 'react'
import UbliqueRow from '../Row'
import UbliqueColumn from '../Column'
import cn from 'classnames'

import './index.scss'

const StripePageTitle = ({ text, className = '', configMenu }) => {
  return (
    <UbliqueRow className={cn('ublique-row-page-title', className)}>
      <UbliqueColumn sm={4} md={4} lg={9}>
        <h2>{text}</h2>
      </UbliqueColumn>
      {!isEmpty(configMenu) && (
        <UbliqueColumn className='dropdown-column' sm={4} md={4} lg={3}>
          <Dropdown {...configMenu} />
        </UbliqueColumn>
      )}
    </UbliqueRow>
  )
}

export default StripePageTitle
